import { LoadingOutlined } from '@ant-design/icons'
import Spin from 'antd/lib/spin'

export const LoadScreen = () => (
  <div style={{ position: 'relative', width: '100%', height: 'calc(100vh - 88px)' }}>
    <Spin
      spinning
      style={{
        backgroundColor: 'transparent',
        position: 'absolute',
        top: '50%',
        right: '50%',
        transform: 'translate(50%, -50%)',
      }}
      indicator={<LoadingOutlined style={{ fontSize: 24, color: 'rgb(22, 119, 255)' }} spin />}
    />
  </div>
)
